export const DUMMY_DATA = [
  {
    id: 1,
    name: 'TestSequence1',
    base: '22',
    price: '$60.04',
    scale: '0.025 µmole',
    purification: 'Desalt',
  },
  {
    id: 2,
    name: 'TestSequence2',
    base: '23',
    price: '$1010.10',
    scale: '0.025 µmole',
    purification: 'Desalt',
  },
  {
    id: 3,
    name: 'TestSequence3',
    base: '24',
    price: '$99.99',
    scale: '0.025 µmole',
    purification: 'Desalt',
  },
]
